import { AvatarStyled } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const WeldAddCrewStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[100]};
    color: ${theme.colors.bechtel.blue[700]};
    border-width: 1px;
    margin-right: ${theme.spacings[300]};
  `};
`;
